import { Link } from 'react-router-dom';

const pageStyle = {
  minHeight: '100vh',
  display: 'grid',
  placeItems: 'center',
  padding: '24px',
  background: '#f5f7fb',
  color: '#17233b',
  fontFamily: "'DM Sans', sans-serif"
};

const cardStyle = {
  width: 'min(460px, 100%)',
  padding: '36px',
  border: '1px solid #e8edf4',
  borderRadius: '16px',
  background: '#fff',
  boxShadow: '0 18px 60px #2b3e5b12'
};

export default function PlatformSignIn({ demoAvailable = false }) {
  return (
    <main style={pageStyle}>
      <section style={cardStyle} aria-labelledby="signin-title">
        <div className="brand-mark" aria-hidden="true">
          AO
        </div>
        <p className="eyebrow" style={{ marginTop: '22px' }}>
          ACADEMYOS · PLATFORM CONTROL
        </p>
        <h1 id="signin-title" style={{ margin: '0 0 10px', fontSize: '27px' }}>
          Platform sign-in
        </h1>
        <p style={{ color: '#6f7c91', fontSize: '13px', lineHeight: 1.7 }}>
          Sign-in is not connected yet. This project has no authentication
          provider or trusted API, so it cannot verify platform staff or protect
          administrative data.
        </p>
        <div
          role="status"
          style={{
            marginTop: '20px',
            padding: '13px',
            border: '1px solid #f0dfbb',
            borderRadius: '9px',
            background: '#fffaf0',
            color: '#846424',
            fontSize: '11px',
            lineHeight: 1.6
          }}
        >
          No account has been created, and there is no public super-admin
          signup. Do not use real customer information in this preview.
        </div>
        {demoAvailable && (
          <p style={{ marginTop: '20px', fontSize: '12px' }}>
            <Link to="/" style={{ color: '#3457d5', fontWeight: 700 }}>
              Return to the fictional demo workspace
            </Link>
          </p>
        )}
      </section>
    </main>
  );
}